/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 16:52:58
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-24 15:56:54
 * @FilePath: \hlweb2.0\src\pages\Home\BriefIntroduction\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useEffect, useState } from "react";
import "./index.scss";
import briefIntroduction1 from "../../../assets/images/home/briefIntroduction1.png";
import { useTranslation } from "react-i18next";
function BriefIntroduction() {
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const briefIntroductionContent = t("home.anchorPoint1Con", { returnObjects: true });

  return (
    <div className="home_brief_" id="home_briefIntroduction_id">
      <div className="home_brief_edition">
        <div className="edition_solution edition_solution_top">
          <div className="edition_solution_title">
            <div>{briefIntroductionContent?.title}</div>
            <span>&nbsp;</span>
          </div>
        </div>
        <div className="home_brief_con">
          <div className="home_brief_con_left">
            <img src={briefIntroduction1} alt="" />
          </div>
          <div className="home_brief_con_right">
            <div className="home_brief_con_right_title">
              {briefIntroductionContent?.content.title}
            </div>
            {briefIntroductionContent?.content.list.map((item, index) => {
              return (
                <p
                  key={index}
                  style={
                    language === "zh"
                      ? { fontSize: "16px" }
                      : { fontSize: "14px" }
                  }
                >
                  {item}
                </p>
              );
            })}
            <div className="home_brief_con_right_footer">
              {briefIntroductionContent?.footList.map((item, index) => {
                return (
                  <div key={index}>
                    <div className="top">{item.top}</div>
                    <div className="bottom">{item.con}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BriefIntroduction;
